import { sbsProjectAPI } from "./api";

export const getSbsProjectList = async (params) => {
  try {
    const res = await sbsProjectAPI.getSbsProjectList(params);
    const data = res?.data;
    const total = res?.total_count;
    return { data, total };
  } catch (e) {}
};

export const getSbsProjectListSimple = async () => {
  try {
    const res = await sbsProjectAPI.getSbsProjectListSimple();
    return res?.data;
  } catch (e) {
    console.error('Error loading SBS projects:', e);
    return [];
  }
};

export const sbsProjectTableColumns = [
  {
    name: "sbs_project_id",
    required: true,
    label: "ID проекта",
    align: "center",
    field: "sbs_project_id",
    sortable: true,
  },
  {
    name: "naimenovanie",
    required: true,
    label: "Наименование",
    align: "left",
    field: "naimenovanie",
    sortable: true,
  },
  {
    name: "inagro_vid_proekta__view",
    required: true,
    label: "Вид проекта",
    align: "left",
    field: "inagro_vid_proekta__view",
    sortable: true,
  },
  {
    name: "klass__view",
    required: true,
    label: "Класс",
    align: "left",
    field: "klass__view",
    sortable: true,
  },
  {
    name: "key__ssylka",
    required: true,
    label: "key__ssylka",
    align: "left",
    field: "key__ssylka",
    sortable: true,
  },
  {
    name: "ssylka__id",
    required: true,
    label: "ssylka__id",
    align: "left",
    field: "ssylka__id",
    sortable: true,
  },
  {
    name: "planovaya_data_nachala",
    required: true,
    label: "Плановая дата начала",
    align: "center",
    field: "naimenovanie",
    sortable: true,
  },
  {
    name: "planovaya_data_okonchaniya",
    required: true,
    label: "Плановая дата окончания",
    align: "center",
    field: "planovaya_data_okonchaniya",
    sortable: true,
  },
  {
    name: "date_modified",
    required: true,
    label: "Дата модификации",
    align: "center",
    field: "date_modified",
    sortable: true,
  },
  {
    name: "updated_at",
    required: true,
    label: "Дата обновления",
    align: "center",
    field: "updated_at",
    sortable: true,
  },
];
